import { NoteEditorController } from '../controller/NoteEditorController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { NoteDisplayMode } from '../types';

export class NoteEditorWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: NoteEditorController,
    });
  }

  get note() {
    const value = this.getAttribute('data-note');
    return value ? JSON.parse(value) : {};
  }

  set note(note) {
    this.propertiesSet = false;
    this.setAttribute('data-note', JSON.stringify(note));
    this.propertiesSet = true;
  }

  set displayMode(value: NoteDisplayMode) {
    if (!value) {
      return;
    }
    this.setAttribute('data-display-mode', value);
  }

  get displayMode(): NoteDisplayMode {
    const value = this.getAttribute('data-display-mode');
    return value ? <NoteDisplayMode>value : NoteDisplayMode.EDIT;
  }
}
